import React from 'react';
import PropTypes from 'prop-types';

// Styled.
import * as S from './styled';

const List = ({ data }) => (
  <S.Container>
    {data.map(({ key, label, value }) => (
      <div key={key || label}>
        <strong>{label}</strong>
        <span>{value}</span>
      </div>
    ))}
  </S.Container>
);

List.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any,
    }),
  ).isRequired,
};

export default List;
